import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/i18n/LanguageContext';

/**
 * Class + Student filter bar for /admin/photos.
 * Purely presentational — parent owns all state.
 */
export const PhotoFilterBar = ({
  classes,
  studentsForFilter,
  selectedClass,
  onClassChange,
  selectedStudent,
  onStudentChange,
}) => {
  const { t } = useLanguage();
  return (
    <>
      {classes.length > 0 && (
        <Select value={selectedClass} onValueChange={onClassChange}>
          <SelectTrigger className="w-[180px] bg-card border-border" data-testid="class-filter-trigger">
            <SelectValue placeholder={t('gallery.filterByClass')} />
          </SelectTrigger>
          <SelectContent className="bg-card border-border">
            <SelectItem value="all">{t('gallery.allClasses')}</SelectItem>
            {classes.map((cls) => (
              <SelectItem key={cls.class_id} value={cls.class_id}>
                {cls.name} ({cls.year})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {studentsForFilter.length > 0 && (
        <Select value={selectedStudent} onValueChange={onStudentChange}>
          <SelectTrigger className="w-[200px] bg-card border-border" data-testid="student-filter-trigger">
            <SelectValue placeholder={t('admin.filterByStudent')} />
          </SelectTrigger>
          <SelectContent className="bg-card border-border max-h-72">
            <SelectItem value="all" data-testid="student-filter-all">{t('admin.allStudents')}</SelectItem>
            {studentsForFilter.map((s) => (
              <SelectItem
                key={s.student_id}
                value={s.student_id}
                data-testid={`student-filter-option-${s.student_id}`}
              >
                {s.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </>
  );
};
